/** Pure game-screen maths for UT. */

export type SlotKind = 'xp' | 'random' | 'reserve';

/**
 * One segment per registrant, in XP order: the first `xpSlots` are XP places,
 * the next `randomSlots` are random places, the rest are reserves.
 */
export function slotSegments(registered: number, xpSlots: number, randomSlots: number): SlotKind[] {
  const out: SlotKind[] = [];
  for (let i = 0; i < registered; i++) {
    out.push(i < xpSlots ? 'xp' : i < xpSlots + randomSlots ? 'random' : 'reserve');
  }
  return out;
}

/** Split a line-up into pitch rows of 3; the last row takes the remainder. */
export function pitchRows<T>(players: T[], perRow = 3): T[][] {
  const rows: T[][] = [];
  for (let i = 0; i < players.length; i += perRow) rows.push(players.slice(i, i + perRow));
  return rows;
}

/** Team pack reveal order: lowest XP first, best card last. Stable for equal XP. */
export function packOrder<T extends { xp: number }>(players: T[]): T[] {
  return players
    .map((p, i) => ({ p, i }))
    .sort((a, b) => a.p.xp - b.p.xp || a.i - b.i)
    .map((x) => x.p);
}

export interface Countdown {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  done: boolean;
}

export function countdownTo(target: Date | string | null | undefined, now: Date = new Date()): Countdown {
  if (!target) return { days: 0, hours: 0, minutes: 0, seconds: 0, done: true };
  const ms = new Date(target).getTime() - now.getTime();
  if (ms <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, done: true };
  const s = Math.floor(ms / 1000);
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    minutes: Math.floor((s % 3600) / 60),
    seconds: s % 60,
    done: false,
  };
}
